module.exports = __webpack_public_path__ + "static/showreelz-e28ba95841156f57ae24652e61f55c11.png";